import { useEffect, useState, type RefObject } from 'react'

/**
 * Rendered pixel size of the waveform box. Both axes are needed: the width decides the sample count and
 * maps a pointer offset to a seek position, the height sets the path's centre line. DS-local copy of the
 * audio-player `useDimensions`.
 */
export const useWaveformDimensions = (
    elementRef: RefObject<HTMLElement | null>,
): [width: number, height: number] => {
    const [size, setSize] = useState<[number, number]>([0, 0])

    useEffect(() => {
        const el = elementRef.current
        if (!el) {
            return undefined
        }

        const update = () => setSize([el.clientWidth, el.clientHeight])
        update()

        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', update)

            return () => window.removeEventListener('resize', update)
        }

        const observer = new ResizeObserver(update)
        observer.observe(el)

        return () => observer.disconnect()
    }, [elementRef])

    return size
}
